module.exports = __webpack_public_path__ + "static/media/cl.609867ee.svg";